import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ENDPOINTS } from "../../../js/api/_config";


export const getWorkflowTrialById = createAsyncThunk('/getWorkflowTrialById', async (data, { rejectWithValue }) => {
    try {
        const response = await axios.get(`${ENDPOINTS.TRIALS.GET_TRIAL_BY_ID}?TrialID=${data.id}`)
        return response.data;
    } catch (error) {
        return rejectWithValue(
            error.response?.data ||
            "Something went wrong while fetching the buyer profile."
        );
    }
})

const initialState = {
    data: [],
    isLoading: true,
    error: null,
};

const getWorkflowTrialByIdSlice = createSlice(
    {
        name: "disease",
        initialState,
        extraReducers: (builder) => {
            builder.addCase(getWorkflowTrialById.fulfilled, (state, action) => {
                state.data = action.payload.data;
                state.isLoading = false;
                state.error = null; 
            })
                .addCase(getWorkflowTrialById.pending, (state) => {
                    state.isLoading = true;
                    state.error = null; 
                })
                .addCase(getWorkflowTrialById.rejected, (state, action) => {
                    state.isLoading = false;
                    state.error = action.payload;
                })
        }
    }
)

export default getWorkflowTrialByIdSlice.reducer;